(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-description-truncated"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fs-collection-description')) {
    class FsCollectionDescription extends HTMLElement {
      #textEl = null;
      #toggleEl = null;
      #labelEl = null;
      #resizeObserver = null;

      connectedCallback() {
        this.#textEl = this.querySelector('.fs-coll-desc__text');
        this.#toggleEl = this.querySelector('.fs-coll-desc__toggle');
        this.#labelEl = this.querySelector('.fs-coll-desc__toggle-label');
        if (!this.#textEl || !this.#toggleEl) return;

        requestAnimationFrame(() => this.#measure());

        if ('ResizeObserver' in window) {
          this.#resizeObserver = new ResizeObserver(() => this.#measure());
          this.#resizeObserver.observe(this.#textEl);
        }

        this.#toggleEl.addEventListener('click', this.#toggle);
      }

      disconnectedCallback() {
        this.#resizeObserver?.disconnect();
        this.#resizeObserver = null;
      }

      #measure = () => {
        if (this.dataset.expanded === 'true') return;
        const overflowing = this.#textEl.scrollHeight - this.#textEl.clientHeight > 2;
        this.#toggleEl.hidden = !overflowing;
      };

      #toggle = () => {
        const next = this.dataset.expanded !== 'true';
        this.dataset.expanded = next ? 'true' : 'false';
        this.#toggleEl.setAttribute('aria-expanded', String(next));
        if (this.#labelEl) {
          this.#labelEl.textContent = next
            ? this.#labelEl.dataset.less
            : this.#labelEl.dataset.more;
        }
      };
    }
    customElements.define('fs-collection-description', FsCollectionDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
